export const formatDollar = (value: number) =>
  `$${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`

export const format = (val: string) => `$` + val
export const parse = (val: string) => val.replace(/^\$/, '')

// Where a sign-in or verification code went (portal-backend services/codeDelivery): "sms"
// (our own number, US/Canada), "verify" (Twilio Verify, for numbers outside the US and
// Canada) or "email" (when no text can go). A response without a channel came from a
// backend older than 2026-10-16, which only ever texted.
export type CodeChannel = "sms" | "verify" | "email"
export interface CodeTarget { channel: CodeChannel, destination: string }

export const codeTargetFrom = (r: { channel?: string, destination?: string, phoneLast4?: string } | null | undefined): CodeTarget => {
  const channel: CodeChannel = r?.channel === "email" || r?.channel === "verify" ? r.channel : "sms"
  return { channel, destination: r?.destination || r?.phoneLast4 || "" }
}

// A texted code keeps the sentence these screens always showed, so US clients see no change.
export const codeSentSentence = ({ channel, destination }: CodeTarget, phoneLast4: string): string =>
  channel === "email"
    ? `We emailed a 6-digit verification code to ${destination || "your email"}.`
    : `We sent a 6-digit verification code to the phone number ending in ${phoneLast4 || destination}.`

/** The message the API put in an error response, if any. */
export const apiErrorMessage = (error: unknown): string | undefined =>
  (error as { response?: { data?: { error?: string } } })?.response?.data?.error